import { useEffect, useRef } from 'react';

interface IScrollState {
  key: string;
  scroll: number;
}

let _store: IScrollState | undefined = undefined;

export default (key: string, smooth?: boolean) => {
  const timeout = useRef<NodeJS.Timeout>();

  useEffect(() => {
    window.history.scrollRestoration = 'manual';

    if (_store?.key === key) {
      setTimeout(() => {
        window.scrollTo({
          left: window.scrollX,
          top: _store?.scroll,
          behavior: smooth ? 'smooth' : 'auto',
        });
      }, 100);
    }

    const onScroll = () => {
      clearTimeout(timeout.current as NodeJS.Timeout);
      timeout.current = setTimeout(() => {
        _store = {
          key,
          scroll: window.scrollY,
        };
      }, 200);
    };

    window.addEventListener('scroll', onScroll);

    return () => {
      clearTimeout(timeout.current as NodeJS.Timeout);
      window.removeEventListener('scroll', onScroll);
      window.history.scrollRestoration = 'manual';
    };
  }, [key]);
};
